/* eslint-disable react/style-prop-object */
/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import {
  Header,
  Footer,
  Comment1,
  Loading,
  ShareButton,
} from '../../../components/index'
import FI from 'react-flickity-component'
import { FiHeart, FiPlusSquare } from 'react-icons/fi'
import { IoDownload } from 'react-icons/io5'
import { Url, UploadsUrl } from '../../../services/url'
import { NumberWithCommas } from '../../../utilities/generator'

const DetailLawer = ({
  id,
  lawyer,
  like,
  loading,
  countLike,
  lastComments,
  LikeDisLike,
  amount,
  setAmount,
  OrderConsulting,
  consultingService,
  setServiceId,
  setType,
  type,
}) => {
  const settingOrder = (data) => {
    setAmount(data.price)
    setServiceId(data._id)
  }
  const flickityOptions = {
    initialIndex: 2,
    prevNextButtons: false,
    pageDots: false,
    rightToLeft: true,
  }
  return (
    <>
      {loading && <Loading />}
      <Header title='جزئیات پروفایل وکیل' />
      {lawyer ? (
        <div className='container'>
          <div className='template-pages'>
            <div className='top-section-single'>
              <div className='click-top-section' onClick={() => LikeDisLike()}>
                {like ? (
                  <FiHeart size={25} fill={'#d81818'} color={'#d81818'} />
                ) : (
                  <FiHeart size={25} />
                )}
                {countLike > 0 && (
                  <div className='count-Likes'>{countLike}</div>
                )}
              </div>
              <div className='avatar'>
                <img
                  className='box-shadow'
                  src={`${UploadsUrl}/${lawyer.avatar}`}
                  alt='user'
                />
              </div>
              <ShareButton url={window.location.href} />
            </div>
            <div className='about-lawer'>
              <div>
                <h2>{`${lawyer.fname} ${lawyer.lname}`}</h2>
                <h5>{lawyer.title}</h5>
              </div>
              {/* <div className='license-number'>
                <span>شماره پروانه وکالت</span>
                <span>95959886</span>
              </div> */}
              {/* <div className='contact'>
                <Link>
                  <BsFillChatFill size={25} />
                </Link>
                <Link>
                  <BsCameraVideoFill size={25} />
                </Link>
                <Link>
                  <FaPhoneAlt size={25} />
                </Link>
              </div> */}
              <div className='layer-shadow'></div>
            </div>
            {/* <div className='text-detail-lawyer'>
              <p>{lawyer.description}</p>
              <div className='layer-shadow'></div>
            </div> */}
            <div className='resume-detail-lawyer'>
              <h3>مشاهده رزمه وکیل</h3>
              <div className='text'>
                <p>{lawyer.resumeText}</p>
              </div>
              <a
                href={`${Url}/${lawyer.resume}`}
                download
                className='btn-download-pdf'
                target='_blank'
              >
                <div className='title'>
                  <span>
                    <IoDownload size={25} />
                  </span>
                  <span>فایل رزمه وکیل</span>
                </div>
                <div>PDF</div>
              </a>
              <div className='layer-shadow'></div>
            </div>

            {lastComments && lastComments.length > 0 && (
              <>
                <div className='comments'>
                  <div className='title'>
                    <h3>نظرات کاربران</h3>
                  </div>
                  {lastComments.map(
                    (comment, index) =>
                      index < 3 && (
                        <Comment1
                          avatar={comment.writer.avatar}
                          name={`${comment.writer.fname} ${comment.writer.lname}`}
                          message={comment.comment}
                          data={comment.createdAt}
                        />
                      )
                  )}
                  {lastComments.length > 3 && (
                    <div className='all-comments-link'>
                      <span>
                        <FiPlusSquare size={25} />
                      </span>
                      <a href={`/comments/${id}`}>مشاهده همه نظرات</a>
                    </div>
                  )}
                  <div className='layer-shadow'></div>
                </div>
              </>
            )}
            <>
              {localStorage.getItem('serviceType') == 'null' && (
                <div className='choose-service'>
                  <div className='title'>
                    <h3>انتخاب نوع خدمت</h3>
                  </div>
                  <div className='select'>
                    <div className={`select-button ${type == 2 && 'active'}`}>
                      <button onClick={() => setType(2)}>مشاوره حضوری</button>
                    </div>
                    <div className={`select-button ${type == 1 && 'active'}`}>
                      <button onClick={() => setType(1)}>
                        مشاوره غیر حضوری
                      </button>
                    </div>
                  </div>
                  <div className='layer-shadow'></div>
                </div>
              )}

              <>
                {type && consultingService.length > 0 ? (
                  <div className='choose-time'>
                    <div className='title'>
                      <h3>انتخاب مدت زمان</h3>
                    </div>
                    <div className={`select`}>
                      <div className={`select-button`}>
                        <FI
                          draggable={true}
                          reloadOnUpdate={false}
                          pageDots={false}
                          options={flickityOptions}
                        >
                          {consultingService.length > 0 &&
                            consultingService.map((item) => (
                              <button
                                className={`${
                                  item.price == amount ? 'active' : ''
                                }`}
                                onClick={() => settingOrder(item)}
                              >{`${item.time} دقیقه`}</button>
                            ))}
                        </FI>
                      </div>
                    </div>
                    <div className='layer-shadow'></div>
                  </div>
                ) : (
                  <h4 className='text-center pt-3'>مدت زمانی تعریف نشده</h4>
                )}

                <div className='register-consulting'>
                  {amount && (
                    <div className='price'>
                      <span>هزینه مشاوره:</span>
                      <span className='amount'>{NumberWithCommas(amount)}</span>
                      <span>تومان</span>
                    </div>
                  )}
                  <div
                    className='btn-register box-shadow'
                    onClick={() => OrderConsulting()}
                  >
                    درخواست را ثبت کنید
                  </div>
                </div>
              </>
            </>
          </div>
        </div>
      ) : (
        <Loading />
      )}
      <Footer />
    </>
  )
}
export default DetailLawer
